<template>
  <b-container class="pt-3">
    <b-button v-print="'#print-order'">列印</b-button>
    <print-page />
  </b-container>
</template>
<script>
import print from "vue-print-nb";
import PrintPage from "@/components/print/order";

export default {
  name: "OrderPrint",
  components: { PrintPage },
  directives: {
    print,
  },
  mounted() {},
};
</script>
